import { Box, useTheme } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

import NavBackButton from "../../../components/NavBackButton";
import CustomButton from "../../../components/CustomButton";

import { useAppSelector } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";

import HambergerMenuButton from "../../../components/HambergerMenuButton";
import Home1SVG from "../../../../media/images/icons/home1";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  hasScroll?: boolean;
  children: JSX.Element;
}

export default function MobileHeader(props: Props) {
  const { children } = props;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { hasScroll } = useAppSelector((state) => state.settings);
  const showHome = pathname === "/login" || pathname === "/signup";
  return (
    <Box
      sx={{
        position: "fixed",
        maxWidth: "450px",
        height: "60px",
        top: "0px",
        width: "100%",
        zIndex: 150,
        backgroundColor: theme.palette.bgColor.grey100,
        boxShadow: hasScroll ? "0px 4px 15px 3px rgba(0,0,0,0.1)" : "none",
        transition: "box-shadow 500ms",
        paddingX: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {showHome ? (
          <CustomButton
            justifyContent="space-between"
            onClick={() => navigate("/")}
            bgColor={blueGrey[400]}
            title="خانه"
            fSize="14px"
            fWeight="600"
            py="8px"
            px="8px"
            gap="4px"
            borderRadius="10px"
            textColor="lightStatic.main"
            icon1={<Home1SVG size={20} color="#fff" />}
          />
        ) : (
          <NavBackButton />
        )}

        {/* <CustomButton
          justifyContent="space-between"
          onClick={() => navigate("/")}
          bgColor={blueGrey[400]}
          title="بازگشت"
          fSize="14px"
          fWeight="600"
          py="6px"
          px="8px"
          gap="4px"
          borderRadius="10px"
          textColor="lightStatic.main"
          icon1={<ArrowRightSVG size={26} color={"#fff"} />}
        /> */}

        <HambergerMenuButton sidbarHandler={setOpenAuthSidebar} />
        {children}
      </Box>
    </Box>
  );
}
